import type { TOC } from '@ember/component/template-only';
import SettingsTransactionMappingDropdownMapping from 'lumen/components/settings/transaction-mapping/dropdown-mapping';
import type { TransactionMappingHierarchyCategory } from 'lumen/models';
import type {
  Category,
  SubCategory,
} from 'lumen/utils/constants/transaction-mapping/constants';

interface SettingsTransactionMappingCellsTdMappingDropdownSignature {
  Args: {
    column: {
      hierarchyCategories: TransactionMappingHierarchyCategory[];
    };
    row: {
      mapItem: (category: Category, subCategory: SubCategory) => void;
    };
  };
}

const SettingsTransactionMappingCellsTdMappingDropdown = <template>
  <div class="td-mapping-dropdown" data-test-id="td-mapping-dropdown">
    <SettingsTransactionMappingDropdownMapping
      @hierarchyCategories={{@column.hierarchyCategories}}
      @onCategorySelect={{@row.mapItem}}
    />
  </div>
</template> satisfies TOC<SettingsTransactionMappingCellsTdMappingDropdownSignature>;

export default SettingsTransactionMappingCellsTdMappingDropdown;
